import { Link } from 'react-router-dom';
import { featureNavItems } from '@/mocks/homeData';

export default function FeatureNavSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 md:mb-14 gap-4">
            <div>
              <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950">
                特色爆料频道
              </h2>
              <p className="mt-2 text-sm text-foreground-500">多维度追踪，全方位吃瓜</p>
            </div>
            <div className="max-w-md">
              <p className="text-sm text-foreground-600 leading-relaxed">
                按分类精准追踪你关心的爆料内容，从网红翻车到明星塌房，从每日大赛到独家视频，一个都不错过。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            <Link
              to={featureNavItems[0].href}
              className="group block bg-background-50 rounded-2xl overflow-hidden hover:bg-background-200/70 transition-all cursor-pointer md:col-span-1"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={featureNavItems[0].image}
                  alt={featureNavItems[0].title}
                  title={featureNavItems[0].title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-6">
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {featureNavItems[0].title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  {featureNavItems[0].description}
                </p>
              </div>
            </Link>

            <Link
              to={featureNavItems[1].href}
              className="group block bg-background-50 rounded-2xl overflow-hidden hover:bg-background-200/70 transition-all cursor-pointer flex flex-col"
            >
              <div className="p-6 pb-3">
                <h3 className="text-lg font-heading font-bold text-foreground-950 text-center group-hover:text-primary-600 transition-colors">
                  {featureNavItems[1].title}
                </h3>
              </div>
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={featureNavItems[1].image}
                  alt={featureNavItems[1].title}
                  title={featureNavItems[1].title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-6 pt-3">
                <p className="text-sm text-foreground-500 leading-relaxed text-center">
                  {featureNavItems[1].description}
                </p>
              </div>
            </Link>

            <Link
              to={featureNavItems[2].href}
              className="group block bg-background-50 rounded-2xl overflow-hidden hover:bg-background-200/70 transition-all cursor-pointer flex flex-col"
            >
              <div className="p-6 pb-3">
                <h3 className="text-lg font-heading font-bold text-foreground-950 text-center group-hover:text-primary-600 transition-colors">
                  {featureNavItems[2].title}
                </h3>
              </div>
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={featureNavItems[2].image}
                  alt={featureNavItems[2].title}
                  title={featureNavItems[2].title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-6 pt-3">
                <p className="text-sm text-foreground-500 leading-relaxed text-center">
                  {featureNavItems[2].description}
                </p>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}